module.exports = "/_next/static/images/Randall_Brooks-0164b413435bfb54d7f7b16385699098.webp";